/* eslint-disable camelcase */
/* eslint-disable no-warning-comments */
/* eslint-disable max-len */
/* eslint-disable no-param-reassign */
import React, {
    useContext, useCallback, useState, useEffect, useRef
} from 'react';
import appConfig from 'app-config';
import { ViewModelServiceContext, ViewModelForm, useDataRefresh } from '@xengage/gw-portals-viewmodel-react';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { FormattedMessage, useTranslator } from '@jutro/locale';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { MLPAEditDriverComponent } from 'ml-components-common-react';
import { MLDriverVehicleUtil, MLWizardNavUtil, MLNotificationBlockUtil } from 'ml-portals-util-react';
import { useModal } from '@jutro/components';
import { MLLocalDateUtil, MLHVQDefaultFieldsUtil, MLDisclosureUtil, convertToSentenceCase } from 'ml-portals-util-js';
import { MLMultiLobsDataHolderService } from 'ml-services-common-react';
import { LocalDateUtil } from '@xengage/gw-portals-util-js';
import { LoadSaveService } from 'gw-capability-quoteandbind';
import { MLModalService, MLTagManagerService } from 'ml-portals-services-react';
import { platformMessages } from 'ml-components-platform-react';
import _ from 'lodash';

import PATrackEvent from 'gw-capability-gateway-quoteandbind-common-react/components/TrackEvent/PATrackEvent';
import wizardConfig from "../../config/pa-wizard-config.json5";
import metadata from './DriversPage.metadata.json5';
import messages from './DriversPage.messages';
import styles from './DriversPage.module.scss';
import { ScrollToError } from '@jutro/legacy/wizard-next';

import { IntlContext } from '@jutro/legacy/locale';

// ML: PADriverDetailsCtrl.js, pa-driver-details.html

function DriversPage(props) {
    const modalApi = useModal();
    const {
        wizardData: submissionVM, goNext, steps, changeNextSteps, currentStep, updateWizardSnapshot, isSkipping
    } = props;
    const viewModelService = useContext(ViewModelServiceContext);
    const translator = useTranslator();
    const { refreshData } = useDataRefresh();
    const [showValidtionErrors, setShowValidtionErrors] = useState(false);
    const [showDisclosureValidtionErrors, setShowDisclosureValidationErrors] = useState(false);
    const [accidentLiveRegionMsg, setAccidentLiveRegionMsg] = useState('');
    const {
        // initialValidation,
        onValidate
        // isComponentValid,
        // disregardFieldValidation
    } = useValidation('DriversPage');
    const { steps: wizardSteps } = wizardConfig;

    const isHVQDriverDetailsStep = currentStep.mlStepName === 'paHVQConsumerDriverDetails';

    const {nextStepVisited} = MLWizardNavUtil(props);

    const {
        showProgressDialog,
        hideProgressDialog
    } = MLModalService();

    const [unobtainableDriverLicenseDisplayed, setUnobtainableDriverLicenseDisplayed] = useState(false);
    const [paSuspensionMessagedDisplayed, setPaSuspensionMessagedDisplayed] = useState(false);
    const [nonAccidentPreventionDisplayed, setNonAccidentPreventionDisplayed] = useState(false);
    const [isAddDisclosureVisible, setIsAddDisclosureVisible] = useState(false);
    const [maxClaimDate, setMaxClaimDate] = useState({});
    const [disclosureVM, setDisclosureVM] = useState({});
    const [errorTimestamp, setErrorTimestamp] = useState(0);
    const driverTypeTypelist = viewModelService.productMetadata.get('pc').types.getTypelist('DriverType_ML');
    const INCIDENT_CATEGORY_TYPELIST = viewModelService.productMetadata.get('pc').types.getTypelist('IncidentCategory_ML');
    const INCIDENT_DESCRIPTION_TYPELIST = viewModelService.productMetadata.get('pc').types.getTypelist('IncidentDescription_ML');

    // Driver Type Constants
    const Household = driverTypeTypelist.getCode('household').code;
    const Excluded = driverTypeTypelist.getCode('excluded').code;
    // const Rated = driverTypeTypelist.getCode('rated').code;

    const {
        HVQConsumerSteps
    } = appConfig;
    
    const isCompRaterDefaultsPage = new Set(HVQConsumerSteps).has(currentStep.mlStepName);
    const nextMessagePendingDrivers = isCompRaterDefaultsPage ? messages.wellReviewYourAdditionalDriversNext : messages.wellWorkOnYourAdditionalDriversNext;
    const nextMessageFinalDriver = isCompRaterDefaultsPage ? messages.wellReviewYourVehiclesNext : messages.wellWorkOnYourVehiclesNext;
    const type = MLDisclosureUtil.getLossType();
    const isClaim = MLDisclosureUtil.isClaimType(type);

    const isQnB = appConfig.portalCode === 'QB';
    const isModernProduct = _.get(submissionVM, 'isModernProduct_Ext.value', false);
    const policyStateCode = _.get(submissionVM, 'baseData.policyAddress.state.value.code');
    const isPersonalAuto = _.get(submissionVM, 'baseData.productName.value');

    const {
        checkUniqueSelf,
        unobtainableDriverLicense,
        displayUnobtainableDriverLicenseMessage,
        clearUnobtainableDriverLicenseMessage,
        pADriverSuspended,
        displayPADriverSuspendedMessage,
        displayNonAccidentPreventionModifierMessage,
        getFullName,
        setDriversForFullAddition,
        setDefaultStatusForRatedDriver,
        setModifierEditMode,
        isAccidentPreventionCourse,
        setSpousesForDriver,
        setDefaultSelfRelation,
        isSpouseRemoved
    } = MLDriverVehicleUtil();

    const {
        clearBlockAlerts,
        addErrorAlert
    } = MLNotificationBlockUtil();

    const intl = useContext(IntlContext);
    const getFormattedDateString = useCallback((gwDateVal) => {
        const date = LocalDateUtil.toMidnightDate(gwDateVal);
        return intl.formatDate(date, { year: 'numeric', month: '2-digit', day: '2-digit' });
    }, [intl]);


    //
    // initialize page
    //
    const initDriverList = () => {
        //
        // Create Driver if needed
        //
        const createDriverVM = () => {
            const primaryNamedInsured = submissionVM.baseData.primaryNamedInsured_ML.value;
            const driverObj = {
                accidents: '0',
                violations: '0',
                lastName: primaryNamedInsured.firstName,
                firstName: primaryNamedInsured.lastName,
                dateOfBirth: primaryNamedInsured.dateOfBirth,
                isPolicyHolder: true,
                person: primaryNamedInsured
            };
            const { _dtoName, _xCenter } = submissionVM.lobData.personalAuto.coverables.drivers;
            const driverVM = viewModelService.create(driverObj, _xCenter, _dtoName);
            submissionVM.lobData.personalAuto.coverables.drivers.pushElement(driverVM);
            return driverVM;
        };

        let drivers = submissionVM.lobData.personalAuto.coverables.drivers.value;
        if (_.isEmpty(drivers)) {
            drivers = [createDriverVM().value];
        }
        setDriversForFullAddition(drivers);
        setModifierEditMode(drivers, true);
        setDefaultStatusForRatedDriver(drivers);
        setDefaultSelfRelation(drivers, submissionVM.baseData.primaryNamedInsured_ML.value);

        return drivers;
    };

    const initDisclosures = (p) => {
        if (!p.currentDriverVM.disclosures_ML.value || p.currentDriverVM.disclosures_ML.value.length === 0) {
            p.currentDriverVM.disclosures_ML.value = { accidents: [], claims: [], violations: [] };
        } else {
            if (p.currentDriverVM.disclosures_ML.accidents.value.length === 0) {
                p.currentDriverVM.disclosures_ML.accidents.value = [];
            } else {
                p.allDisclosures.push(...p.currentDriverVM.disclosures_ML.accidents.value);
            }
            if (p.currentDriverVM.disclosures_ML.claims.value.length === 0) {
                p.currentDriverVM.disclosures_ML.claims.value = [];
            } else {
                p.allDisclosures.push(...p.currentDriverVM.disclosures_ML.claims.value);
            }
            if (p.currentDriverVM.disclosures_ML.violations.value.length === 0) {
                p.currentDriverVM.disclosures_ML.violations.value = [];
            } else {
                p.allDisclosures.push(...p.currentDriverVM.disclosures_ML.violations.value);
            }
        }
    };

    const initPageState = (index = 0) => {
        const p = {
            currentIdx: index,
            currentDriverVM: undefined,
            allDisclosures: [],
            ratedDriverVMList: []
        };

        const setEditingDriverIndex = () => {
            const indexOfNewlyAddedDriver = p.ratedDriverVMList.findIndex((rDriverVM) => rDriverVM.value.tempID);
            if (indexOfNewlyAddedDriver >= 0) {
                p.currentIdx = indexOfNewlyAddedDriver;
            } else {
                p.currentIdx = index;
            }
            p.currentDriverVM = p.ratedDriverVMList[p.currentIdx];
            p.currentDriverVM.disclosures_ML.value = _.get(p.currentDriverVM, 'disclosures_ML.value') || [];
            return p;
        };

        // Only display rated drivers
        const driverList = _.sortBy(initDriverList().filter((driver) => {return driver.type_ML === 'rated';}), (driver) => {
            if (driver.publicID) {
                return _.toInteger(driver.publicID.split(':')[1]);
            }
            return undefined;
        });

        p.ratedDriverVMList = driverList.map((driver) => {
            return submissionVM.lobData.personalAuto.coverables.drivers.findFirstElement(driver);
        });

        setEditingDriverIndex();
        initDisclosures(p);
        return p;
    };

    const [page, setPage] = useState(initPageState);

    const nextPageState = (driverIndex) => {
        page.currentIdx = driverIndex;
        page.currentDriverVM = page.ratedDriverVMList[page.currentIdx];
        page.currentDriverVM.disclosures_ML.value = page.currentDriverVM.disclosures_ML.value || [];
        initDisclosures(page);

        refreshData();
    };

    //
    // Helper
    //
    const getDriverList = () => {
        return page.ratedDriverVMList.map((driverVM) => driverVM.value);
    };

    const indexOfDriver = (driver) => {
        return page.ratedDriverVMList.indexOf(driver);
    };

    const isFinalDriver = (driver) => {
        return indexOfDriver(driver) === (page.ratedDriverVMList.length - 1);
    };

    const disableEditModeIfNonRated = (driver) => {
        if (driver.type_ML === Household || driver.type_ML === Excluded) {
            driver.editMode_ML = false;
        }
    };

    const isDriverValid = () => {
        return page.currentDriverVM.aspects.subtreeValid;
    };

    const ensureUniqueLicenseNumber = (driver) => {
        const driverMatch = _.every(getDriverList(), { licenseNumber: driver.licenseNumber });
        if (!driverMatch) {
            return undefined;
        }
        if (driverMatch.length === 1) {
            return driverMatch[0] !== driver ? driverMatch : undefined;
        }
        return _.find(driverMatch, (d) => {
            return d !== driver;
        });
    };

    const isValid = () => {
        if (!isDriverValid() || !checkUniqueSelf(getDriverList())) {
            setTimeout(() => {
            setShowValidtionErrors(true);
            setErrorTimestamp(errorTimestamp + 1);
            }, 100)
            return false;
        }
        const licenceMatchedDriver = ensureUniqueLicenseNumber(page.currentDriverVM.value);
        if (licenceMatchedDriver) {
            const msg = translator(messages.licenseMatchingMsg, { driver: licenceMatchedDriver.getDisplayName() });
            const title = translator(messages.licenseNumberNotUnique);

            modalApi.showAlert({
                status: 'error', /* status - 'info', 'warning', 'error', or 'success' */
                icon: 'mi-error-outline', /* icon - optional icon class name for the icon to display to the left of the title */
                title: `${title}`, /* title - string/IntlMessageShape for the title of the alert */
                message: `${msg}`, /* message - string/IntlMessageShape for the message to display within the alert */
                confirmButtonText: 'OK' /* confirmButtonText - string/IntlMessageShape for the text to appear on the confirm button */
            });

            return false;
        }
        return true;
    };

    const nextDriver = () => {
        if (unobtainableDriverLicense(page.currentDriverVM.licenseState) && !unobtainableDriverLicenseDisplayed) {
            displayUnobtainableDriverLicenseMessage(false);
            setUnobtainableDriverLicenseDisplayed(true);
            return;
        }
        disableEditModeIfNonRated(page.currentDriverVM.value);
        if (isValid() && page.currentIdx < page.ratedDriverVMList.length - 1) {
            nextPageState(page.currentIdx + 1);
            setUnobtainableDriverLicenseDisplayed(false);
            clearUnobtainableDriverLicenseMessage();

            window.scrollTo(0, 0);
        }
    };

    const next = async() => {
        if (pADriverSuspended(submissionVM) && !paSuspensionMessagedDisplayed) {
            displayPADriverSuspendedMessage();
            setPaSuspensionMessagedDisplayed(true);
            return false;
        }
        if (unobtainableDriverLicense(page.currentDriverVM.licenseState) && !unobtainableDriverLicenseDisplayed) {
            displayUnobtainableDriverLicenseMessage(false);
            setUnobtainableDriverLicenseDisplayed(true);
            return false;
        }

        const { drivers } = submissionVM.value.lobData.personalAuto.coverables;
        const policyStateCode = submissionVM.baseData.policyAddress.state.value.code;
        if (isAccidentPreventionCourse(drivers, policyStateCode) && !nonAccidentPreventionDisplayed) {
            displayNonAccidentPreventionModifierMessage();
            setNonAccidentPreventionDisplayed(true);
            return false;
        }
        drivers.forEach((driver) => {
            disableEditModeIfNonRated(driver);
        });

        if (!isValid()) {
            return false;
        }

        PATrackEvent('Quote Step Submitted', false, submissionVM, null, { step: 'Drivers Screen'}, true);

        // save and move to next page
        let nextStepName;
        showProgressDialog(platformMessages.saveSubmission);
        if (submissionVM.value.isConsumerCompRater()) {
            _.set(submissionVM, 'portalCurrentStep_ML.value', 'paHVQConsumerDriverDetails');
            MLDisclosureUtil.setRequoteAfterMvr(submissionVM.quoteID.value, false);
            nextStepName = 'paHVQConsumerVehicleDetails';
            MLMultiLobsDataHolderService.storeFlowSteps(currentStep.mlStepName, nextStepName);
            hideProgressDialog();
            if (!nextStepVisited()) {
                return submissionVM;
            }
            goNext();
        } else {
            _.unset(submissionVM.value, 'bindData');
            _.set(submissionVM, 'portalCurrentStep_ML.value', 'paDriverDetails');
            try {
                const res = await LoadSaveService.updateDraftSubmission(submissionVM.value);
                submissionVM.value = res;
            } finally {
                const paModel = submissionVM.lobData.personalAuto.coverables.value;
                updateWizardSnapshot(submissionVM);

                if (paModel.hasNamedNonOwner() || paModel.vehicles.length === 0) {
                    const index = _.findIndex(
                        steps,
                        ({ path }) => path === '/vehicles'
                    );
                    if (index > 0) {
                        const remainingSteps = _.slice(steps, index + 1);
                        changeNextSteps(remainingSteps);
                    }
                    nextStepName = 'paAddtlInfoToQuote';
                } else {
                    const hasVehicleStep = steps.some((step) => step.path === '/vehicles');
                    if (!hasVehicleStep) {
                        const vehicleIndex = _.findIndex(
                            wizardSteps, ({ path }) => path === '/vehicles'
                        );
                        const nextSteps = _.slice(wizardSteps, vehicleIndex);
                        changeNextSteps(nextSteps);
                    }
                    nextStepName = 'paVehicleDetails';
                }

                MLMultiLobsDataHolderService.storeFlowSteps(currentStep.mlStepName, nextStepName);
                hideProgressDialog();
            }
            if (!nextStepVisited()) {
                return submissionVM;
            }
            goNext();
        }
        return false;
    };

    const editDriver = (evt) => {
        if (isValid() && evt.index < page.currentIdx) {
            nextPageState(evt.index);
            window.scrollTo(0, 0);
        }
    };

    //
    // Disclosure
    //
    const createNewDisclosure = (discCategory) => {
        const newDisclosureFields = {
            source: 'customer_disclosed'
        };
        const DISCLOSURE_TYPES = {
            ACCIDENT: INCIDENT_CATEGORY_TYPELIST.getCode('accident'),
            CLAIM: INCIDENT_CATEGORY_TYPELIST.getCode('other_claim'),
            VIOLATION: INCIDENT_CATEGORY_TYPELIST.getCode('violation')
        };
        let newDisclosure;
        switch (discCategory) {
            case (DISCLOSURE_TYPES.ACCIDENT.code):
                newDisclosure = viewModelService.create(newDisclosureFields, 'pc',
                    'metlife.edge.capabilities.policycommon.disclosures.dto.AccidentDTOML');
                newDisclosure.date = disclosureVM.date.value;
                newDisclosure.paidAmount = { amount: undefined };
                break;
            case (DISCLOSURE_TYPES.CLAIM.code):
                newDisclosure = viewModelService.create(newDisclosureFields, 'pc',
                    'metlife.edge.capabilities.policycommon.disclosures.dto.ClaimDTOML');
                newDisclosure.date = disclosureVM.date.value;
                newDisclosure.paidAmount = { amount: undefined };
                break;
            case (DISCLOSURE_TYPES.VIOLATION.code):
                newDisclosure = viewModelService.create(newDisclosureFields, 'pc',
                    'metlife.edge.capabilities.policycommon.disclosures.dto.ViolationDTOML');
                newDisclosure.date = disclosureVM.date.value;
                newDisclosure.state = submissionVM.baseData.policyAddress.state.value;
                break;
            default:
                newDisclosure = viewModelService.create(newDisclosureFields, 'pc',
                    'metlife.edge.capabilities.policycommon.disclosures.dto.AccidentDTOML');
                newDisclosure.paidAmount = { amount: undefined };
                newDisclosure.date = undefined;
                discCategory = undefined;
                break;
        }
        newDisclosure.value.category = discCategory;
        newDisclosure.person = page.currentDriverVM.person.value;
        newDisclosure.value.isCategoryRequired = true;
        return newDisclosure;
    };

    const isClaimDisclosure = (disc) => disc?.category === "other_claim";

    const hasClaimDisclosure = page.allDisclosures?.some((disc) =>
      isClaimDisclosure(disc),
    );

    const onDisclosureCategoryChange = (discCategoryChange) => {
        const previousDate = disclosureVM.date.value;
        setDisclosureVM(createNewDisclosure(discCategoryChange));

        disclosureVM.date.value = previousDate;
    };

    const hasAnyPriorDisclosures = () => {
        return page.allDisclosures.length > 0;
    };

    const hasPrefilledDisclosures = () => {
        return page.allDisclosures.some((d) => d.source !== 'customer_disclosed');
    };

    const hasManuallyEnteredDisclosures = () => {
        return hasAnyPriorDisclosures() && page.allDisclosures.some((d) => d.source === 'customer_disclosed');
    };

    const isCustomerDisclosure = (disc) => {
        return disc.source === 'customer_disclosed';
    };

    const isFieldDefaultedByHvq = useCallback((inputID) => {
        return submissionVM.value.isConsumerCompRater()
            && MLHVQDefaultFieldsUtil.isFieldDefaultedByHVQ(submissionVM.value.compRaterVendorName_ML, inputID, currentStep.mlStepName);
    }, [currentStep.mlStepName, submissionVM.value]);

    const isBridgedAndDefaultedDisclosure = useCallback((disc) => {
        return !!disc.bridgedFromHVQ_ML && !!isCompRaterDefaultsPage && !!isFieldDefaultedByHvq('incident');
    }, [isCompRaterDefaultsPage, isFieldDefaultedByHvq]);

    const isViolationDisclosure = (disc) => {
        return disc.category === 'violation';
    };

    const removePriorDisclosure = (evt) => {
        let idx = evt.index;

        const disc = page.allDisclosures[idx];
        page.allDisclosures.splice(idx, 1);

        switch (disc.category) {
            case ('accident'):
                idx = disc.publicID ? page.currentDriverVM.disclosures_ML.accidents.value.findIndex((accident) => accident.publicID === disc.publicID) : page.currentDriverVM.disclosures_ML.accidents.value.indexOf(disc);
                if (idx > -1) {
                    page.currentDriverVM.disclosures_ML.accidents.value.splice(idx, 1);
                }
                break;
            case ('other_claim'):
                idx = disc.publicID ? page.currentDriverVM.disclosures_ML.claims.value.findIndex((claim) => claim.publicID === disc.publicID) : page.currentDriverVM.disclosures_ML.claims.value.indexOf(disc);
                if (idx > -1) {
                    page.currentDriverVM.disclosures_ML.claims.value.splice(idx, 1);
                }
                break;
            case ('violation'):
                idx = disc.publicID ? page.currentDriverVM.disclosures_ML.violations.value.findIndex((violation) => violation.publicID === disc.publicID) : page.currentDriverVM.disclosures_ML.violations.value.indexOf(disc);
                if (idx > -1) {
                    page.currentDriverVM.disclosures_ML.violations.value.splice(idx, 1);
                }
                break;
            default:
                break;
        }

        setPage({ ...page });

        MLTagManagerService.sendLinkClickEvent(`${MLTagManagerService.getStepName()}_Remove Incident`);
    };

    const showAddDisclosureSection = () => {
        MLTagManagerService.sendLinkClickEvent(`${MLTagManagerService.getStepName()}_Add Incident`);
        setMaxClaimDate(MLLocalDateUtil.date2LocalDate(new Date()));
        maxClaimDate.day -= 1;
        setDisclosureVM(createNewDisclosure());
        setIsAddDisclosureVisible(true);

        setAccidentLiveRegionMsg("Add accident section Expanded")
    };

    const hideAddDisclosureSection = () => {
        setIsAddDisclosureVisible(false);
        setShowDisclosureValidationErrors(false);
    };

    const finishAddingDisclosure = () => {
        if (disclosureVM.aspects.valid && disclosureVM.aspects.subtreeValid) {
            if (disclosureVM.category && disclosureVM.category.value && disclosureVM.category.value.code === 'violation') {
                disclosureVM.paidAmount = undefined;
            }

            if (disclosureVM.paidAmount && disclosureVM.paidAmount.value) {
                disclosureVM.paidAmount.currency = 'usd';
            }

            switch (disclosureVM.value.category) {
                case ('accident'):
                    page.currentDriverVM.disclosures_ML.accidents.value.push(disclosureVM.value);
                    break;
                case ('other_claim'):
                    page.currentDriverVM.disclosures_ML.claims.value.push(disclosureVM.value);
                    break;
                case ('violation'):
                    page.currentDriverVM.disclosures_ML.violations.value.push(disclosureVM.value);
                    break;
                default:
                    break;
            }
            page.allDisclosures.push(disclosureVM.value);
            hideAddDisclosureSection();
            MLTagManagerService.sendFormStepEvent(MLTagManagerService.getFormName(), `${MLTagManagerService.getStepName()}_Save Incident`);
        } else {
            setShowDisclosureValidationErrors(true);
        }
    };

   const isWeatherLossEditable = (index) => {
     const disc = page.allDisclosures?.[index];

     return disc?.weatherLossEditable === true;
   };

    const setWeatherLossValue = (index, value) => {
      if(!isQnB) return
    const selectedDisclosure = page.allDisclosures[index];
 
    if (!selectedDisclosure || selectedDisclosure.category !== 'other_claim') {
        return;
    }
 
    const claimsVM = page.currentDriverVM.disclosures_ML.claims;
    const claims = claimsVM.value || [];
 
    const claimIndex = claims.findIndex(
        (claim) => claim.publicID === selectedDisclosure.publicID
    );
 
    if (claimIndex === -1) return;
 
    const updatedClaims = [...claims];
 
    updatedClaims[claimIndex] = {
        ...updatedClaims[claimIndex],
        weatherLoss: value === 'true',
    };
 
    claimsVM.value = updatedClaims;
 
    setPage((previousPage) => ({
        ...previousPage,
        allDisclosures: previousPage.allDisclosures.map(
            (disc, i) =>
                i === index
                    ? { ...disc, weatherLoss: value === 'true' }
                    : disc
        ),
    }));
};
    
    //
    // Modifier
    //
    const disableValidationForDependentModifiers = (mod) => {
        if (mod && mod.hasDependentModifier_ML.value) {
            getDriverList().forEach((driver) => {
                if (!_.isEmpty(driver.driverModifiers_ML)) {
                    driver.driverModifiers_ML.modifiers.forEach((modifier) => {
                        if (modifier.isDependentModifier_ML) {
                            modifier.editMode_ML = false;
                        }
                    });
                }
            });
        }
    };

    const checkClaimDetails = () => {
        if (isAddDisclosureVisible) {
            finishAddingDisclosure();
            return true;
        }
        return false;
    }

    const checkForUniqueLicenseNumbers = () => {
        clearBlockAlerts('duplicateLicense');

        const drivers = submissionVM.lobData.personalAuto.coverables.drivers.value.filter((d) => {
            return d.licenseNumber && (d.type_ML === 'rated' || d.type_ML === 'excluded');
        });
        const seen = new Set();
        let hasDuplicate = false;

        drivers.forEach((d) => {
            if (seen.has(d.licenseNumber)) {
                hasDuplicate = true;
            } else {
                seen.add(d.licenseNumber);
            }
        });

        if (hasDuplicate) {
            addErrorAlert(messages.showDuplicateLicenseError, 'duplicateLicense');

            return false;
        }

        return true;
    };

    const updateModifiers = (mod) => {
        const setEditMode = (editMode) => submissionVM.value.lobData.personalAuto.coverables.drivers.forEach((driver) => {
            driver.editMode_ML = editMode;
            driver.isSchoolAddressRequired_Ext = editMode;
            driver.schoolAddress_Ext = undefined;
        });

        const setEditModeVehicle = (editMode) => submissionVM.value.lobData.personalAuto.coverables.vehicles.forEach((vehicle) => {
            vehicle.editMode_ML = editMode;
        });

        setEditModeVehicle(false);
        disableValidationForDependentModifiers(mod);
        // Disable validation so we can update the model and the driver modifiers with it
        setEditMode(false);
        updateDriverModifier();
        const submissionLoadPromise = LoadSaveService.updateModifiers(submissionVM.value);
        showProgressDialog(platformMessages.syncing, submissionLoadPromise, true);
        submissionLoadPromise.then((qdd) => {
            submissionVM.value.lobData.personalAuto.coverables.drivers.length = 0;
            const sortedDrivers = _.sortBy(qdd.lobData.personalAuto.coverables.drivers, (driver) => {
                if (driver.publicID) {
                    return _.toInteger(driver.publicID.split(':')[1]);
                }
                return undefined;
            });
            sortedDrivers.forEach((updatedDriver) => {
                if (updatedDriver.person) {
                    _.set(updatedDriver, 'person', submissionVM.value.findPerson(submissionVM.value, updatedDriver.person));
                }
                submissionVM.value.lobData.personalAuto.coverables.drivers.push(updatedDriver);
            });
            setSpousesForDriver(sortedDrivers);
            setDriversForFullAddition(sortedDrivers);

            submissionVM.value.lobData.personalAuto.coverables.vehicles.length = 0;
            qdd.lobData.personalAuto.coverables.vehicles.forEach((updatedVehicle) => {
                submissionVM.value.lobData.personalAuto.coverables.vehicles.push(updatedVehicle);
            });

            setPage(initPageState(page.currentIdx));
        }, (error) => {
            console.error(error);
        }).finally(() => {
            setModifierEditMode(submissionVM.value.lobData.personalAuto.coverables.drivers, true);
        });
    };

    const nextStepText_Ext = () => {
        return isFinalDriver(page.currentDriverVM) ? (
            <FormattedMessage
                {...nextMessageFinalDriver}
                values={{
                    vehicles: (
                        <strong>{translator(messages.vehicles)}</strong>
                    )
                }}
            />
        ) : (
            <FormattedMessage
                {...nextMessagePendingDrivers}
                values={{
                    additionalDrivers: (
                        <strong>{translator(messages.additionalDrivers)}</strong>
                    )
                }}
            />
        );
    };
    
    const updateDriverModifier = () => {
        if (!isQnB) return;
        const drivers = _.get(submissionVM, 'lobData.personalAuto.coverables.drivers.value', []);
        drivers.forEach((driver) => {
            const modifiers = _.get(driver, 'driverModifiers_ML.modifiers', []);
            modifiers.filter((mod) => mod.codeIdentifier_ML === 'PADriverSignalProgramPhoneNumber_Ext')
                .forEach((mod) => {
                    _.defaults(mod, { chosenTermValue: 'null' });
                    _.set(mod, 'isInputValueRequired_ML', false);
                    _.set(mod, 'updated', true);
                });
        });
        _.set(submissionVM, 'lobData.personalAuto.coverables.drivers.value', drivers);
        updateWizardSnapshot(submissionVM);
    }

    const checkAndRemoveSchoolAddressIfNotDistantStudent = () => {
        if (isModernProduct) {
            page.ratedDriverVMList.forEach((driver) => {
                const modifiersList = driver?.driverModifiers_ML?.modifiers?.value;
                if (Array.isArray(modifiersList)) {
                    modifiersList.forEach((modifier) => {
                        if (modifier.codeIdentifier_ML === 'PADistantStudent_Ext') {
                            if (modifier.chosenTermValue === 'true') {
                                driver.isSchoolAddressRequired_Ext = true;
                            } else {
                                driver.schoolAddress_Ext = undefined;
                                driver.isSchoolAddressRequired_Ext = false;
                            }
                        }
                    });
                }
            });
        }
    };

    const checkAndBypassEmptyPhoneNumberForSignalProgram = () => {
        page.ratedDriverVMList.forEach((driver) => {
            const modifiersList = driver?.driverModifiers_ML?.modifiers?.value;
            if (Array.isArray(modifiersList)) {
                modifiersList.forEach((modifier) => {
                    if (modifier.codeIdentifier_ML === "PADriverSignalProgramPhoneNumber_Ext") {
                        modifier.isInputValueRequired_ML = false;
                    }
                });
            }
        });
    };

    const navigateToInvalidDriver = () => {
      const invalidDriverIndex = page.ratedDriverVMList.findIndex(
        (driverVM) => !driverVM?.aspects?.subtreeValid,
      );

      if (invalidDriverIndex !== -1) {
        nextPageState(invalidDriverIndex);
        setShowValidtionErrors(true);
        setErrorTimestamp(Date.now());

        return true;
      }

      return false;
    };

    const checkSpouse = (drivers) => {
        if (!isQnB) return;
    const getPersonId = (driver) =>
        driver?.person?.publicID || driver?.person?.tempID;
 
    const activeDrivers = drivers.filter(
        (driver) => driver?.maritalStatus_ML === 'M'
    );
 
    const spouseDrivers = drivers.filter(
        (driver) => driver?.relationshipToInsured_ML === 'spouse'
    );
 
    if (spouseDrivers.length > 1) {
        return false;
    }
 
    for (const driver of activeDrivers) {
        const driverId = getPersonId(driver);
        const spouseId = driver?.spouseID_ML;
 
        if (!driverId || !spouseId) {
            continue;
        }
 
        if (String(driverId) === String(spouseId)) {
            return false;
        }
 
        const selectedSpouse = activeDrivers.find(
            (d) => String(getPersonId(d)) === String(spouseId)
        );
 
        if (
            selectedSpouse?.spouseID_ML &&
            String(selectedSpouse.spouseID_ML) !== String(driverId)
        ) {
            return false;
        }
 
        const duplicateSelection = activeDrivers.some(
            (otherDriver) =>
                otherDriver !== driver &&
                String(otherDriver.spouseID_ML) === String(spouseId)
        );
 
        if (duplicateSelection) {
            return false;
        }
    }
 
    return true;
};

    //
    // ViewModelForm settings
    //

    const onNext = () => {
        const drivers = _.get(submissionVM, "lobData.personalAuto.coverables.drivers.value", []);
        if (page.currentDriverVM?.maritalStatus_ML?.value?.code === "M" && !page.currentDriverVM?.spouseID_ML?.value) {
            clearBlockAlerts("checkNoSpouseQB");
          addErrorAlert(messages.checkNoSpouseQB,"checkNoSpouseQB");
          return false;
        }
      if ( !page.currentDriverVM?.dateOfBirth?.value && page.currentDriverVM?.fromPrefill_ML?.value ) {
        setShowValidtionErrors(true);
        setErrorTimestamp(Date.now());
        return false;
      }
      checkAndBypassEmptyPhoneNumberForSignalProgram();
      checkAndRemoveSchoolAddressIfNotDistantStudent();
      updateDriverModifier();
      setDriversForFullAddition([page.currentDriverVM.value]);
      if (isQnB && (!checkForUniqueLicenseNumbers() || checkClaimDetails())) {
        return false;
      }
      if (isQnB) {
        const pniDriver = page.ratedDriverVMList.find(
          (driverVM) => driverVM?.isPolicyHolder?.value,
        );
        const pniMaritalStatus = pniDriver?.maritalStatus_ML?.value?.code;
        const isCurrentDriverSpouse =
          page.currentDriverVM?.relationshipToInsured_ML?.value?.code ===
          "spouse";

        clearBlockAlerts("invalidSpouseRelationship");
        if (pniMaritalStatus === "S" && isCurrentDriverSpouse) {
          addErrorAlert(
            messages.singlePNICannotHaveSpouse,
            "invalidSpouseRelationship",
          );
          return false;
        } else {
          clearBlockAlerts("invalidSpouseRelationship");
          }
        if (!isSpouseRemoved(drivers)) {
          clearBlockAlerts("NoSpouseForPNI");
          addErrorAlert(messages.noSpouseAddedtoPNI, "NoSpouseForPNI");
          return false;
        } else {
          clearBlockAlerts("NoSpouseForPNI");
          }
      }
      const currentDriverVM = page.currentDriverVM;

      const maritalStatus =currentDriverVM?.maritalStatus_ML?.value?.code ??
      currentDriverVM?.maritalStatus_ML?.value;

      // Clear spouse selection when marital status is not Married
      if ( maritalStatus && maritalStatus !== "M" && currentDriverVM?.spouseID_ML?.value) {
          _.set(currentDriverVM, 'spouseID_ML.value', null);
      }

      const latestDrivers = _.get(submissionVM, "lobData.personalAuto.coverables.drivers.value", []);
      clearBlockAlerts("checkUniqueSpouseMessageQB");
      if (latestDrivers.length && !checkSpouse(latestDrivers)) {
        addErrorAlert(
          messages.checkUniqueSpouseMessageQB,
          "checkUniqueSpouseMessageQB",
        );
        return false;
      }
      if (navigateToInvalidDriver()) {
        return false;
      }
      if (isFinalDriver(page.currentDriverVM)) {
        return next();
      }
      setShowValidtionErrors(false);
      nextDriver();
    };

    // const {
    //     onValidate,
    // } = useValidation('DriversPage');

    const handleDriverModelChange = useCallback((spouseDriver) => {
        if (!isQnB || !spouseDriver) return;

        setPage((previousPageState) => {
            const existingDrivers = previousPageState.ratedDriverVMList || [];

            const driverAlreadyExists = existingDrivers.some(
                (driver) => driver.publicID === spouseDriver.publicID
            );

            const updatedDriversList = driverAlreadyExists
                ? existingDrivers.map((driver) =>
                    driver.publicID === spouseDriver.publicID
                        ? spouseDriver
                        : driver
                )
                : [...existingDrivers, spouseDriver];

            return {
                ...previousPageState,
                ratedDriverVMList: updatedDriversList,
            };
        });
    }, [setPage, isQnB]); 

    const generateEditDriverOverrides = () => {
        const getRightRailRowClassName = (driver) => {
            const isCompleteDriver = (d) => {
                return indexOfDriver(d) < page.currentIdx;
            };

            const isCurrentDriverVM = (d) => {
                return indexOfDriver(d) === page.currentIdx;
            };

            if (isCompleteDriver(driver)) {
                return 'editable';
            }
            if (isCurrentDriverVM(driver)) {
                return 'current-icon';
            }
            return 'pending-icon';
        };

        const overrides = page.ratedDriverVMList.map((driver, index) => {
            return {
                [`driveRowIconSpan${index}`]: {
                    className: getRightRailRowClassName(driver)
                }
            };
        });

        return Object.assign({}, ...overrides);
    };

    const formatAvailableValues = (viewModel) => {
        if (!viewModel) return [];
        return viewModel.aspects.availableValues.map((availableValue) => ({
            code: availableValue.code,
            name: translator({
                id: availableValue.name,
                defaultMessage: availableValue.name
            })
        }));
    };

    const generateAddDisclosureOverrides = () => {
        return {
            allDisclosuresIterable: {
                data: page.allDisclosures
            },
            allDisclosuresTableContainer: {
                visible: hasAnyPriorDisclosures()
            },
            showPriorDisclosure: {
                visible: hasAnyPriorDisclosures(),
                className: isQnB ? "" : "vertical-spacing-30"
            },
            showPrefilledDisclosureDescription: {
                visible: hasPrefilledDisclosures()
            },
            showManualDisclosureDescription: {
                visible: !hasPrefilledDisclosures() && hasManuallyEnteredDisclosures()
            },
            accidentLiveRegion: {
                content: isQnB ? accidentLiveRegionMsg : ""
            },
            showDisclosureButton: {
                visible: !isAddDisclosureVisible,
                type: isQnB ? "outlined" : "filled",
                className: isQnB ? "secondaryButton w-216" : "",
                content: isQnB ? convertToSentenceCase(translator(messages.showDisclosureButtonText)) : translator(messages.showDisclosureButtonText)
            },
            addDisclosureTopContainer: {
                visible: isAddDisclosureVisible
            },
            cancelDisclosureButton: {
                className: isQnB ? "secondaryButton" : ""
            },
            nextButton: {
                className: isQnB ? "primaryButton" : ""
            },
            addDisclosureDateOfEvent: {
                value: disclosureVM.date ? disclosureVM.date.value : undefined,
                onValueChange: (value) => {
                    const updatedDisclosure = _.clone(disclosureVM);
                    updatedDisclosure.date.value = value;
                    setDisclosureVM(updatedDisclosure);
                },
                showErrors: showDisclosureValidtionErrors,
                className: isQnB ? "col-md-6-qb" : ""
            },
            addDisclosureCategory: {
                availableValues: formatAvailableValues(disclosureVM.category),
                value: disclosureVM.category && disclosureVM.category.value ? disclosureVM.category.value : '',
                onValueChange: onDisclosureCategoryChange,
                showErrors: showDisclosureValidtionErrors,
                className: isQnB ? "col-md-6-qb" : ""
            },
            addDisclosureType: {
                availableValues: formatAvailableValues(disclosureVM.type),
                disabled: _.isUndefined(disclosureVM.category) || _.isUndefined(disclosureVM.category.value),
                value: disclosureVM.type && disclosureVM.type.value ? disclosureVM.type.value : '',
                onValueChange: (value) => {
                    const updatedDisclosure = _.clone(disclosureVM);
                    updatedDisclosure.type.value = value;
                    setDisclosureVM(updatedDisclosure);
                },
                showErrors: showDisclosureValidtionErrors,
                className: isQnB ? "col-md-6-qb" : ""
            },
            addDisclosureAmountPaid: {
                visible: disclosureVM.category && disclosureVM.category.value && disclosureVM.category.value.code !== 'violation',
                showFractions: true,
                value: disclosureVM.paidAmount && disclosureVM.paidAmount.amount ? disclosureVM.paidAmount.amount.value : undefined,
                onValueChange: (value) => {
                    const paidAmoutValue = Math.max(0, Number(value)); 
                    const updatedDisclosure = _.clone(disclosureVM);
                    updatedDisclosure.paidAmount.amount.value = paidAmoutValue;
                    setDisclosureVM(updatedDisclosure);
                },
                showErrors: showDisclosureValidtionErrors,
                className: isQnB ? "col-md-6-qb" : ""
            },
            addDisclosureRow: {
                className: isQnB ? "addDisclosureRow vertical-spacing-40 addDisclosureRowQB" : "addDisclosureRow vertical-spacing-40"
            },
            actionRow: {
                className: isQnB ? "row col-md-4 buttonFlex" : "row col-md-12"
            }
        };
    };

    const generateAllDisclsuresOverrides = () => {
        const getTypeKeyDescription = (typeKeyName) => {
            return translator({
                id: typeKeyName,
                defaultMessage: typeKeyName
            });
        };

        const overrides = page.allDisclosures.map((disc, index) => {
            return {
              [`dateCell${index}`]: {
                content: getFormattedDateString(disc.date),
              },
              [`dateCellStatus${index}`]: {
                visible: isCustomerDisclosure(disc),
              },
              [`dateAlertIcon${index}`]: {
                visible: isBridgedAndDefaultedDisclosure(disc),
              },
              [`driverCell${index}`]: {
                content: getFullName(disc.person).toUpperCase(),
              },
              [`categoryCell${index}`]: {
                content: getTypeKeyDescription(
                  INCIDENT_CATEGORY_TYPELIST.getCode(disc.category).name,
                ),
              },
              [`typeCell${index}`]: {
                content: disc.type
                  ? getTypeKeyDescription(
                      INCIDENT_DESCRIPTION_TYPELIST.getCode(disc.type).name,
                    )
                  : "",
              },
              [`cellWeatherLoss${index}`]: {
                  visible: (hasClaimDisclosure || isClaim) && isModernProduct && isPersonalAuto && policyStateCode ==='AR'
              },
              [`weatherLossDropDown${index}`]: {
                availableValues: [
                  {
                    code: "true",
                    name: translator(messages.weatherLossYes),
                  },
                  {
                    code: "false",
                    name: translator(messages.weatherLossNo),
                  },
                ],
                visible: isWeatherLossEditable(index),
                value: typeof disc?.weatherLoss === "boolean"
                    ? disc.weatherLoss.toString()
                    : "",
                onValueChange: (value) => {
                  setWeatherLossValue(index, value);
                },
              },
              [`amountPaidCell${index}`]: {
                content: disc.paidAmount ? `$${disc.paidAmount.amount}` : "",
              },
              [`amountPaidAlertIcon${index}`]: {
                visible:
                  !isViolationDisclosure(disc) &&
                  isBridgedAndDefaultedDisclosure(disc),
              },
              [`actionCell${index}`]: {
                visible: isCustomerDisclosure(disc),
              },
            };
        });

        return Object.assign({}, ...overrides);
    };

    const generateDriverListOverrides = () => {
        const overrides = page.ratedDriverVMList.map((driver, index) => {
            return {
                [`driverName${index}`]: {
                    content: getFullName(driver.person.value)
                }
            };
        });

        return Object.assign({}, ...overrides);
    };

    const overrideProps = {
        driversIterable: {
            data: getDriverList()
        },
        editDriverSection: {
            className: isQnB ? 'col-md-8 qbPadding' : 'col-md-8'
        },
        editDriverHeader: {
            content: translator(messages.paDriverMainSectionHeader, {
                index: page.currentIdx + 1,
                length: page.ratedDriverVMList.length
            })
        },
        paEditDriverComponent: {
            key: page.currentDriverVM.publicID.value,
            submissionVM: submissionVM,
            driverVM: page.currentDriverVM,
            driverList: getDriverList(),
            showValidtionErrors: showValidtionErrors,
            handleDriverModelChange: handleDriverModelChange,
            updateModifiers: updateModifiers,
            isFieldDefaultedByHvq
        },
        nextDescription: {
            content: isFinalDriver(page.currentDriverVM)
                ? (
                    <FormattedMessage
                        {...nextMessageFinalDriver}
                        values={{
                            vehicles: (
                                <strong>{translator(messages.vehicles)}</strong>
                            )
                        }}
                    />
                )
                : (
                    <FormattedMessage
                        {...nextMessagePendingDrivers}
                        values={{
                            additionalDrivers: (
                                <strong>{translator(messages.additionalDrivers)}</strong>
                            )
                        }}
                    />
                )
        },
        hvqPageTitle: {
            visible: isHVQDriverDetailsStep
        },
        hvqPageSubTitle: {
            visible: isHVQDriverDetailsStep
        },
        saveDisclosureButton: {
            className: isQnB ? "margin-right-20 saveButtonNoBorderQB accentButton" : "margin-right-20"
        },
        weatherLossHeaderContainer: {
         visible: (hasClaimDisclosure || isClaim) && isModernProduct && isPersonalAuto && policyStateCode === 'AR'
        },
        ...generateDriverListOverrides(),
        ...generateEditDriverOverrides(),
        ...generateAddDisclosureOverrides(),
        ...generateAllDisclsuresOverrides()
    };

    const readValue = (id, path) => {
        return readViewModelValue(metadata.pageContent, page.ratedDriverVMList, id, path, overrideProps);
    };

    const resolvers = {
        resolveValue: readValue,
        resolveComponentMap: {
            mlpaeditdrivercomponent: MLPAEditDriverComponent
        },
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            onNext: onNext,
            onValidate: onValidate,
            editDriver: editDriver,
            showAddDisclosureSection: showAddDisclosureSection,
            finishAddingDisclosure: finishAddingDisclosure,
            hideAddDisclosureSection: hideAddDisclosureSection,
            onDisclosureCategoryChange: onDisclosureCategoryChange,
            removePriorDisclosure: removePriorDisclosure
        }
    };

    const skipOnResumeIf = () => {
        if (!!_.get(submissionVM, 'bindData.policyNumber.value')
            && (submissionVM.value.baseData.status_ML === 'Bound' || submissionVM.value.baseData.status_ML === 'Binding')) {
            return true;
        }

        if (submissionVM.value.isConsumerCompRater()) {
            return MLMultiLobsDataHolderService.hasCompletedStep(currentStep.mlStepName);
        }

        if (currentStep.mlStepName === 'paHVQConsumerDriverDetails' && !(submissionVM.hvqQuoteID_ML && submissionVM.hvqQuoteID_ML.value)) {
            return true;
        }

        if (MLMultiLobsDataHolderService.getLastVisitedStep() === currentStep.mlStepName) {
            return false;
        }

        if (MLMultiLobsDataHolderService.getLastVisitedStep() === 'quoteDetails' &&
            submissionVM.hvqQuoteID_ML.value &&
            submissionVM.isBundle_ML.value) {
            return true;
        }

        if (submissionVM.isBundle_ML.value
            && submissionVM.value.baseData.status_ML !== 'Draft') {
            return true;
        }

        return submissionVM.value.lobData.personalAuto.coverables.drivers[0]
            && submissionVM.value.lobData.personalAuto.coverables.drivers[0].gender;
    };

    useEffect(() => {
            if (!isSkipping) {
                PATrackEvent('Quote Step Reached', false, submissionVM, null, { step: 'Drivers Screen'}, true);
            }
    }, [isSkipping])
    
    useEffect(() => {
        if (skipOnResumeIf()) {
            const paModel = submissionVM.lobData.personalAuto.coverables.value;
            if (paModel.hasNamedNonOwner() || paModel.vehicles.length === 0) {
                const index = _.findIndex(
                    steps,
                    ({ path }) => path === '/vehicles'
                );
                if (index > 0) {
                    const remainingSteps = _.slice(steps, index + 1);
                    changeNextSteps(remainingSteps);
                }
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <WizardPage
            showCancel={false}
            showPrevious={false}
            skipWhen={skipOnResumeIf}
            showNext={!nextStepVisited() && isFinalDriver(page.currentDriverVM)}
            onNext={onNext}
            nextLabel={translator(platformMessages.mlContinue)}
            showTextNextToButton={!nextStepVisited() && isFinalDriver(page.currentDriverVM)}
            textNextToButton={nextStepText_Ext()}
            metadataPageId={!nextStepVisited() && isFinalDriver(page.currentDriverVM) && _.get(metadata, 'pageContent.id')}
        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                overrideProps={overrideProps}
                resolveValue={readValue}
                callbackMap={resolvers.resolveCallbackMap}
                componentMap={resolvers.resolveComponentMap}
                classNameMap={resolvers.resolveClassNameMap}
                model={disclosureVM}
                onValidationChange={onValidate}
                showErrors={showValidtionErrors}
            />
            <ScrollToError counter={errorTimestamp} />
        </WizardPage>
    );
}

DriversPage.propTypes = wizardProps;
export default DriversPage;
